module.exports = __webpack_public_path__ + "img/face-smile-upside-down.e80245cf.svg";